import {
    Grid,
    IconButton,
    InputAdornment,
    TextField,
    withStyles
} from "@material-ui/core";
import {Field} from "formik";
import classNames from "classnames";
import * as PropTypes from "prop-types";
import style from "./styles";
import React from "react";
import {IconFechar} from "../icons/MateraIcons";
import is from "is_js";

const InputTextBuilder = (props) => {
    const {classes, fieldSchema: schema, form} = props;
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} onBlur={schema.onBlur ?? form.onBlur} {...props}  required={schema.isRequired}>
            {
                ({field, form}) => {
                    return <TextField
                        className={classes.margin}
                        label={schema.label}
                        InputLabelProps={{
                            className: classes.label,
                            htmlFor: schema.label + '-field'
                        }}
                        InputProps={{
                            id: schema.label + '-field',
                            ...field,
                            onBlur: schema.onBlur?.(form),
                            value: field.value ?? '',
                            autoComplete: "off",
                            className: classNames(classes.margin, classes.textField),
                            disabled: schema.disabled,
                            endAdornment: <>
                                {
                                    is.not.empty(field.value) && !schema.disableClear &&
                                    <InputAdornment position="end" className={'clear'}>
                                        <IconButton tabIndex="-1" size={"small"} onClick={() => form.setFieldValue(schema.field, null)}>
                                            <IconFechar size={16}/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                                {
                                    schema.adornment && (schema?.adornment?.condition ?? true) &&
                                    <InputAdornment position="end" className={'clear'}>
                                        <IconButton tabIndex="-1" size={"small"} onClick={schema.adornment.onClick}>
                                            <schema.adornment.icon fontSize={"small"}/>
                                        </IconButton>
                                    </InputAdornment>
                                }
                            </>,
                        }}
                    />
                }
            }
        </Field>
    </Grid>;
};


InputTextBuilder.propTypes = {
    classes: PropTypes.any,
    fieldSchema: PropTypes.any
};

export default withStyles(style)(InputTextBuilder);
